import { useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import { Funnel } from 'react-bootstrap-icons'; // Bootstrap icon for "filter"

const PostFilter = ({ posts, onApply }) => {
  const [filters, setFilters] = useState({
    state: '',
    city: '',
    service: '',
    propertyType: '',
  });
  const [show, setShow] = useState(false);

  const getUnique = (key) =>
    [...new Set(posts.map((post) => post[key]).filter(Boolean))];

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    onApply(filters);
    setShow(false);
  };

  const handleReset = () => {
    setFilters({ state: '', city: '', service: '', propertyType: '' });
  };

  return (
    <>
      <Button
        variant="outline-dark"
        onClick={() => setShow(true)}
        title="Filter"
      >
        <Funnel className="me-1" />
        Filter
      </Button>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Filter Posts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="d-flex flex-column gap-3">
            <Form.Select
              value={filters.state}
              onChange={(e) => handleChange('state', e.target.value)}
            >
              <option value="">Select State</option>
              {getUnique('state_name').map((state) => (
                <option key={state}>{state}</option>
              ))}
            </Form.Select>

            <Form.Select
              value={filters.city}
              onChange={(e) => handleChange('city', e.target.value)}
            >
              <option value="">Select City</option>
              {getUnique('city_name').map((city) => (
                <option key={city}>{city}</option>
              ))}
            </Form.Select>

            <Form.Select
              value={filters.service}
              onChange={(e) => handleChange('service', e.target.value)}
            >
              <option value="">Select Service</option>
              {getUnique('service').map((service) => (
                <option key={service}>{service}</option>
              ))}
            </Form.Select>

            {/* <Form.Select
              value={filters.propertyType}
              onChange={(e) => handleChange('propertyType', e.target.value)}
            >
              <option value="">Select Property Type</option>
              {getUnique('property_type').map((type) => (
                <option key={type}>{type}</option>
              ))}
            </Form.Select> */}
          </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button variant="secondary" onClick={handleReset}>
            Reset
          </Button>
          <Button variant="primary" onClick={handleApply}>
            Apply Filters
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PostFilter;
